/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OdChargeIdEnum } from './odChargeIdEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface MetricInfoResponse { 
    metric_name: string;
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
    internal_charge_id: string;
    metric_uom: string;
    od_charge_id: OdChargeIdEnum;
    id?: number;
    created_ts?: Date;
    updated_ts?: Date;
}
export namespace MetricInfoResponse {
}


